import { motion } from "framer-motion";
import { Lock } from "lucide-react";

interface TokenIconProps {
  icon: string;
  isPrivate?: boolean;
  size?: "sm" | "md" | "lg";
}

const iconColors: Record<string, string> = {
  coti: "from-cyan-400 to-blue-500",
  weth: "from-indigo-400 to-purple-500",
  wbtc: "from-orange-400 to-yellow-500",
  usdc: "from-blue-400 to-blue-600",
  wada: "from-blue-500 to-cyan-400",
  usdt: "from-green-400 to-emerald-500",
};

const iconLabels: Record<string, string> = {
  coti: "C",
  weth: "Ξ",
  wbtc: "₿",
  usdc: "$",
  wada: "₳",
  usdt: "₮",
};

const sizeClasses = {
  sm: "w-8 h-8 text-sm",
  md: "w-10 h-10 text-base",
  lg: "w-14 h-14 text-xl",
};

const TokenIcon = ({ icon, isPrivate = false, size = "md" }: TokenIconProps) => {
  const isImagePath = icon.includes('/') || icon.includes('.');
  const gradient = !isImagePath ? (iconColors[icon] || "from-gray-400 to-gray-600") : "";
  const label = !isImagePath ? (iconLabels[icon] || "?") : "";

  return (
    <motion.div
      whileHover={{ scale: 1.1 }}
      className={`
        ${sizeClasses[size]} rounded-full flex items-center justify-center relative
        ${isImagePath ? 'bg-transparent' : `bg-gradient-to-br ${gradient}`}
        ${isImagePath ? 'bg-transparent' : `bg-gradient-to-br ${gradient}`}
      `}
    >
      {isImagePath ? (
        <img
          src={icon}
          alt="token"
          className="w-full h-full object-contain rounded-full"
        />
      ) : (
        <span className="text-foreground drop-shadow-lg">{label}</span>
      )}

      {isPrivate && (
        <div className={`
          absolute flex items-center justify-center bg-orange-500 rounded-full border-2 border-background z-10
          ${size === 'sm' ? '-bottom-1 -right-1 w-4 h-4 p-[2px]' :
            size === 'md' ? '-bottom-1 -right-1 w-5 h-5 p-[3px]' :
              '-bottom-1 -right-1 w-6 h-6 p-1'}
        `}>
          <Lock className="w-full h-full text-foreground" strokeWidth={3} />
        </div>
      )}
    </motion.div>
  );
};

export default TokenIcon;
